import React from 'react';
import { motion } from 'framer-motion';
const cards = [{
  emoji: '🍔',
  title: 'COMIDAS QUE YA CONOCEN',
  description: <>
        Milanesas, hamburguesas, pizza, helados... pero{' '}
        <strong data-id="element-87">con verduras escondidas que no van a detectar</strong>
      </>
}, {
  emoji: '🍽️',
  title: 'NUTRICIÓN COMPLETA',
  description: <>
        <strong data-id="element-88">Hierro, vitaminas, minerales</strong>... todo integrado en sus
        comidas favoritas para que <strong data-id="element-89">crezcan sanos y fuertes</strong>
      </>
}, {
  emoji: '😊',
  title: 'SIN PELEAS NI NEGOCIACIONES',
  description: <>
        <strong data-id="element-90">Tu hijo va a PEDIR estas comidas</strong> porque están realmente
        riquísimas
      </>
}, {
  emoji: '🛒',
  title: 'INGREDIENTES DE SUPERMERCADO',
  description: <>
        Nada raro ni caro. Todo con lo que ya tenés en casa o conseguís en
        cualquier súper o <strong data-id="element-91">almacén de barrio</strong>
      </>
}];
export function FeaturesSection() {
  return <section className="pt-10 pb-10 bg-violet-100" data-id="element-92">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-93">
        {/* Top bullets */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-10 space-y-3" data-id="element-94">
          <p className="text-2xl md:text-3xl font-extrabold" data-id="element-95">
            <span className="text-yellow-500" data-id="element-96">⭐</span>{' '}
            <span className="text-violet-600" data-id="element-97">
              No son recetas "saludables"...
            </span>{' '}
            <span className="text-gray-800" data-id="element-98">
              Son las comidas que ya aman pero{' '}
            </span>
            <span className="text-orange-500" data-id="element-99">súper nutritivas</span>
            <span className="text-gray-800" data-id="element-100">, aprenderás a </span>
            <span className="bg-gradient-to-r from-orange-500 via-violet-600 to-emerald-500 bg-clip-text text-transparent" data-id="element-101">
              camuflar
            </span>
            <span className="text-gray-800" data-id="element-102">
              {' '}
              todos los nutrientes que ellos necesitan
            </span>
          </p>
          <p className="text-2xl md:text-3xl font-extrabold" data-id="element-103">
            <span className="text-orange-400" data-id="element-104">📋</span>{' '}
            <span className="text-gray-800" data-id="element-105">Más de </span>
            <span className="text-emerald-600" data-id="element-106">200 recetas probadas</span>{' '}
            <span className="text-gray-800" data-id="element-107">
              por miles de familias de todo el país
            </span>
          </p>
        </motion.div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-108">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-md flex flex-col items-center text-center gap-4" data-id="element-109">
              <span className="text-5xl" data-id="element-110">{card.emoji}</span>
              <h3 className="text-violet-600 font-extrabold text-base uppercase leading-tight" data-id="element-111">
                {card.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-112">
                {card.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}